import React from 'react'
import {encode as base64_encode} from 'base-64';
export const ProgressScreenC = ({id, user_contents,total_contents,coursesL}) => {

    const disCourse = ()=>{
        // let couseL = coursesL.find(course => course.id === id)
        // let couseL = JSON.parse(window.sessionStorage.getItem(`listCourse${id}`))
        let couseL = coursesL

        return (
            <div className="content-progress">
                <div className="ct-progress">
                    <img className="img-progress" src = {(couseL.icon_button_type==='svg')?`data:image/svg+xml;base64,${base64_encode(couseL.icon_button)}`:`data:image/${couseL.icon_button_type}+xml;base64,${btoa(couseL.icon_button)}`} alt={couseL.name}/>
                </div>
                <div className="ct-progress-b">
                    <span  className="ct-progress-b-txt">{couseL.name}</span>
                    <div className="percent" style={{backgroundImage: `linear-gradient(to right, ${couseL.seconday_color}, ${couseL.primary_color})`, backgroundSize: `${(user_contents!==0)?Math.round((user_contents/total_contents)*100):0}% 100%`}}>{(user_contents!==0)?Math.round((user_contents/total_contents)*100):0}%</div>
                </div>
                <br/>
                <br/>
            </div>
        )
    }

    return (
        <>
            {disCourse()}
        </>
    )
}
